import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
    selector: '[appTenDigitNumber]'
  })
  export class TenDigitNumberDirective {

    constructor(private el: ElementRef) {
    }
    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
      let current: string = this.el.nativeElement.value;
      console.log(event.key)
      if (event.key != "Enter") {
        if (current.length == 10 || event.key == "." || event.key == "e") {
          event.preventDefault();
          return;
        }
      }
    }
  }